// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/HvDTrial_Brandon_Grotesque_light-BF64a625c93e709.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/HvDTrial_Brandon_Grotesque_black-BF64a625c944b08.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Fontspring-DEMO-proximanova-medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Florsn01.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/BricolageGrotesque-VariableFont_opsz,wdth,wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/PTSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root {
  --doc-height: 100%;
  --doc-width: 100%;
  width: 100%;
  height: 100%;
 }

body {
  width: '100%';
  height: '100%';
  background-color: #fcfcf6;
  overflow-x: hidden; /* Hide horizontal scrollbar */
  height: var(--doc-height);
}

.menuBarOpen {
  width: 100%; 
  text-align: center; 
  background-color: #fcfcf6;
}

.menuBarClosed {
  width: 100%; 
  text-align: center;
  height: 65vh;
  background-color: #6f6b5d;
  animation: slideIn 0.5s cubic-bezier(0.17, 0.04, 0.03, 0.94);
}
.menuBarTextClosed {
  cursor: pointer; 
  font-family: florenescans; 
  font-size: 0.75em; 
  font-style: normal;
  letter-spacing: 0.2em;
  line-height: 1.4em; 
  font-weight: 500; 
  text-transform: uppercase;
  color: #FCFCF7B3; 
  white-space: pre-line; 
  padding-top: 1.25em; 
  padding-bottom: 1.25em;
}
.menuBarTextOpen {
  cursor: pointer; 
  font-family: florenescans; 
  font-size: 0.75em; 
  font-style: normal;
  letter-spacing: 0.2em;
  line-height: 1.4em; 
  font-weight: 500; 
  text-transform: uppercase;
  color: #6d674f; 
  white-space: pre-line; 
  padding-top: 1.25em; 
  padding-bottom: 1.25em;
}
.menuOpen {
  width: 100vw;
  height: 100vh;
  background-color: #fcfcf6;
  overflow-x: hidden; /* Hide horizontal scrollbar */
  height: var(--doc-height);
}
 
root {
  background-color: #fcfcf6;
  width: '100vw';
  height: '100vh';
  overflow-x: hidden; /* Hide horizontal scrollbar */
}

@font-face {
  font-family: 'brandon-grotesque';
  src: local('brandon-grotesque'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
  /* other formats include: 'woff2', 'truetype, 'opentype',
                            'embedded-opentype', and 'svg' */
}
@font-face {
  font-family: 'brandon-grotesque';
  src: local('brandon-grotesque-bold'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
  /* other formats include: 'woff2', 'truetype, 'opentype',
                            'embedded-opentype', and 'svg' */
}

@font-face {
  font-family: 'proxima-nova';
  src: local('proxima-nova'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype');
  /* other formats include: 'woff2', 'truetype, 'opentype',
                            'embedded-opentype', and 'svg' */
}

@font-face {
  font-family: 'florenescans';
  src: local('florenescans'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  /* other formats include: 'woff2', 'truetype, 'opentype',
                            'embedded-opentype', and 'svg' */
}

@font-face {
  font-family: 'bricolage-grotesque';
  src: local('bricolage-grotesque'), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
  /* other formats include: 'woff2', 'truetype, 'opentype',
                            'embedded-opentype', and 'svg' */
}

@font-face {
  font-family: 'PT Sans';
  src: local('PT Sans'), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
  /* other formats include: 'woff2', 'truetype, 'opentype',
                            'embedded-opentype', and 'svg' */
}

.subImages {
  position: relative; 
  max-width: 100%; 
  height:45em; 
  object-fit: scale-down; 
  align-self: center; 
  display: inline-block;
  animation-name: none
}

.subImagesMobile {
  position: relative; 
  max-width: 75%; 
  object-fit: scale-down; 
  align-self: center; 
  display: inline-block;
  animation-name: none
}
.subImages2 {
  position: relative; 
  max-width: 100%; 
  height:45em; 
  object-fit: scale-down; 
  align-self: center; 
  display: inline-block;
  animation-name: none;
}
.subImages.fade {
    animation: fadeIn 0.25s ease-in;
}

.PagesMobile {
  font-family: 'PT Sans'; 
  font-style: normal;
  line-height: 1.8em;
  font-size: 1em; 
  color: #FCFCF7B3;
  padding: 0.4em;
  font-weight: 590;
  cursor: pointer;
}

.Pages {
  font-family: 'PT Sans'; 
  font-style: normal;
  line-height: 1.8em;
  font-size: 11px; 
  color: rgb(91, 87, 72);
  padding: 0.2em;
  font-weight: 590;
  cursor: pointer;

}

.Pages:hover {
  animation: changeColor 0.25s ease; /* Animation for zooming in */
  cursor: pointer;
  color: rgb(22, 21, 21);

}

.OtherPagesMobile {
  font-family: 'proxima-nova'; 
  cursor: pointer;
  font-style: normal;
  line-height: 1.8em;
  font-size: 1em; 
  color: #FCFCF7B3;
  padding: 0.4em;
  font-weight: 400;
  letter-spacing: 0.22px;
  padding-bottom: 1em

}

.OtherPages {
  font-family: 'proxima-nova'; 
  cursor: pointer;
  font-style: normal;
  line-height: 1.8em;
  font-size: 11px; 
  color: rgb(91, 87, 72);
  padding: 0.2em;
  font-weight: 400;
  letter-spacing: 0.22px;

}

.OtherPages:hover {
  animation: changeColor 0.25s ease; /* Animation for zooming in */
  cursor: pointer;
  color: rgb(22, 21, 21);

}


@keyframes changeColor {
  from {
    color: rgb(91, 87, 72);
  }
  to {
    color: rgb(22, 21, 21);
  }
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.zoomed-background {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%; 
  background-color: rgba(0,0,0,0.9);
  animation: fadeToBlack 1s ease;
  transition-timing-function: cubic-bezier(.25,.15,.65,.25);
}
@keyframes fadeToBlack {
  from {background-color: rgba(0,0,0,0);}
  to {background-color: rgba(0,0,0,0.9);}
}

.zoomed-photo {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  animation: zoomIn 0.5s ease; /* Animation for zooming in */
  transition: filter 0.5s ease;
  transition-timing-function: cubic-bezier(.25,.15,.65,.25);
  animation-timing-function: cubic-bezier(.25,.15,.65,.25);
  font-size: 0pt;
}

.zoomed-photo.active {
  animation: fadeIn 0.5s ease; /* Animation for zooming in */
  transition: filter 0.5s ease;
  transition-timing-function: cubic-bezier(.25,.15,.65,.25);
  animation-timing-function: cubic-bezier(.25,.15,.65,.25);
}

@keyframes zoomIn {
  from {
    opacity: 0; /* Initial opacity */
    font-size: 0pt;
  }
  to {
    opacity: 1; /* Final opacity */
    font-size: 0pt;
  }
}

.zoomed-text {
  text-align: center;
  color: #ddddd0;
  width: 50%;
  animation: fadeIn 1.2s ease-in; /* Animation for zooming in */
  animation-timing-function: cubic-bezier(.83,.24,.75,.54);
  font-size: 12pt;
}

.zoomed-title-text {
  font-weight: bold;
  text-align: center;
  color: #ddddd0;
  padding: 2.5vh;
  font-size: 12pt;
  animation: fadeIn 1s linear; /* Animation for zooming in */
  animation-timing-function: cubic-bezier(.83,.24,.75,.54);
}

.zoomed-text-odd {
  text-align: center;
  color: #ddddd0;
  width: 50%;
  animation: fadeIn 1.7s ease-in; /* Animation for zooming in */
  animation-timing-function: cubic-bezier(.83,.24,.75,.54);
  font-size: 12pt;

}

.zoomed-title-text-odd {
  font-weight: bold;
  text-align: center;
  color: #ddddd0;
  padding: 2.5vh;
  font-size: 12pt;
  animation: fadeIn 0.3s ease-in; /* Animation for zooming in */
  animation-timing-function: cubic-bezier(.83,.24,.75,.54);


}

@keyframes fadeIn {
  from {
    opacity: .5; /* Initial opacity */
    font-size: 12pt;
  }
  to {
    opacity: 1; /* Final opacity */
    font-size: 12pt;
  }
}

@keyframes slideIn {
  from {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    /* height: 56vh; */

    transform: translateY(-100%);
    opacity: 0.5; /* Initial opacity */
    font-size: 12pt;
  }
  to {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    /* height: 56vh; */
    transform: translateY(0%);
    opacity: 1; /* Final opacity */
    font-size: 12pt;
  }
}

@keyframes slideOut {
  from {
    opacity: 1; /* Initial opacity */
    opacity: 1; /* Initial opacity */
    font-size: 12pt;
  }
  to {
    opacity: 0; /* Final opacity */
    transform: translateY(-100%);
    opacity: 0; /* Final opacity */
    font-size: 12pt;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/App.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;CACb;;AAED;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,kBAAkB,EAAE,8BAA8B;EAClD,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,4DAA4D;AAC9D;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB,EAAE,8BAA8B;EAClD,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB,EAAE,8BAA8B;AACpD;;AAEA;EACE,gCAAgC;EAChC,2FAAsH;EACtH;4DAC0D;AAC5D;AACA;EACE,gCAAgC;EAChC,gGAA2H;EAC3H;4DAC0D;AAC5D;;AAEA;EACE,2BAA2B;EAC3B,sFAAmG;EACnG;4DAC0D;AAC5D;;AAEA;EACE,2BAA2B;EAC3B,sFAAyE;EACzE;4DAC0D;AAC5D;;AAEA;EACE,kCAAkC;EAClC,6FAAsH;EACtH;4DAC0D;AAC5D;;AAEA;EACE,sBAAsB;EACtB,iFAA0E;EAC1E;4DAC0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB;AACF;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;IACI,+BAA+B;AACnC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,eAAe;;AAEjB;;AAEA;EACE,iCAAiC,EAAE,6BAA6B;EAChE,eAAe;EACf,sBAAsB;;AAExB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB;;AAEF;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;;AAExB;;AAEA;EACE,iCAAiC,EAAE,6BAA6B;EAChE,eAAe;EACf,sBAAsB;;AAExB;;;AAGA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,8BAA8B;EAC9B,yDAAyD;AAC3D;AACA;EACE,MAAM,+BAA+B,CAAC;EACtC,IAAI,iCAAiC,CAAC;AACxC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,2BAA2B,EAAE,6BAA6B;EAC1D,4BAA4B;EAC5B,yDAAyD;EACzD,wDAAwD;EACxD,cAAc;AAChB;;AAEA;EACE,2BAA2B,EAAE,6BAA6B;EAC1D,4BAA4B;EAC5B,yDAAyD;EACzD,wDAAwD;AAC1D;;AAEA;EACE;IACE,UAAU,EAAE,oBAAoB;IAChC,cAAc;EAChB;EACA;IACE,UAAU,EAAE,kBAAkB;IAC9B,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,8BAA8B,EAAE,6BAA6B;EAC7D,wDAAwD;EACxD,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;EACf,2BAA2B,EAAE,6BAA6B;EAC1D,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,8BAA8B,EAAE,6BAA6B;EAC7D,wDAAwD;EACxD,eAAe;;AAEjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;EACf,8BAA8B,EAAE,6BAA6B;EAC7D,wDAAwD;;;AAG1D;;AAEA;EACE;IACE,WAAW,EAAE,oBAAoB;IACjC,eAAe;EACjB;EACA;IACE,UAAU,EAAE,kBAAkB;IAC9B,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,kBAAkB;;IAElB,4BAA4B;IAC5B,YAAY,EAAE,oBAAoB;IAClC,eAAe;EACjB;EACA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,UAAU,EAAE,kBAAkB;IAC9B,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU,EAAE,oBAAoB;IAChC,UAAU,EAAE,oBAAoB;IAChC,eAAe;EACjB;EACA;IACE,UAAU,EAAE,kBAAkB;IAC9B,4BAA4B;IAC5B,UAAU,EAAE,kBAAkB;IAC9B,eAAe;EACjB;AACF","sourcesContent":["\n:root {\n  --doc-height: 100%;\n  --doc-width: 100%;\n  width: 100%;\n  height: 100%;\n }\n\nbody {\n  width: '100%';\n  height: '100%';\n  background-color: #fcfcf6;\n  overflow-x: hidden; /* Hide horizontal scrollbar */\n  height: var(--doc-height);\n}\n\n.menuBarOpen {\n  width: 100%; \n  text-align: center; \n  background-color: #fcfcf6;\n}\n\n.menuBarClosed {\n  width: 100%; \n  text-align: center;\n  height: 65vh;\n  background-color: #6f6b5d;\n  animation: slideIn 0.5s cubic-bezier(0.17, 0.04, 0.03, 0.94);\n}\n.menuBarTextClosed {\n  cursor: pointer; \n  font-family: florenescans; \n  font-size: 0.75em; \n  font-style: normal;\n  letter-spacing: 0.2em;\n  line-height: 1.4em; \n  font-weight: 500; \n  text-transform: uppercase;\n  color: #FCFCF7B3; \n  white-space: pre-line; \n  padding-top: 1.25em; \n  padding-bottom: 1.25em;\n}\n.menuBarTextOpen {\n  cursor: pointer; \n  font-family: florenescans; \n  font-size: 0.75em; \n  font-style: normal;\n  letter-spacing: 0.2em;\n  line-height: 1.4em; \n  font-weight: 500; \n  text-transform: uppercase;\n  color: #6d674f; \n  white-space: pre-line; \n  padding-top: 1.25em; \n  padding-bottom: 1.25em;\n}\n.menuOpen {\n  width: 100vw;\n  height: 100vh;\n  background-color: #fcfcf6;\n  overflow-x: hidden; /* Hide horizontal scrollbar */\n  height: var(--doc-height);\n}\n \nroot {\n  background-color: #fcfcf6;\n  width: '100vw';\n  height: '100vh';\n  overflow-x: hidden; /* Hide horizontal scrollbar */\n}\n\n@font-face {\n  font-family: 'brandon-grotesque';\n  src: local('brandon-grotesque'), url(../fonts/HvDTrial_Brandon_Grotesque_light-BF64a625c93e709.otf) format('opentype');\n  /* other formats include: 'woff2', 'truetype, 'opentype',\n                            'embedded-opentype', and 'svg' */\n}\n@font-face {\n  font-family: 'brandon-grotesque';\n  src: local('brandon-grotesque-bold'), url(../fonts/HvDTrial_Brandon_Grotesque_black-BF64a625c944b08.otf) format('opentype');\n  /* other formats include: 'woff2', 'truetype, 'opentype',\n                            'embedded-opentype', and 'svg' */\n}\n\n@font-face {\n  font-family: 'proxima-nova';\n  src: local('proxima-nova'), url(../fonts/Fontspring-DEMO-proximanova-medium.otf) format('opentype');\n  /* other formats include: 'woff2', 'truetype, 'opentype',\n                            'embedded-opentype', and 'svg' */\n}\n\n@font-face {\n  font-family: 'florenescans';\n  src: local('florenescans'), url(../fonts/Florsn01.ttf) format('truetype');\n  /* other formats include: 'woff2', 'truetype, 'opentype',\n                            'embedded-opentype', and 'svg' */\n}\n\n@font-face {\n  font-family: 'bricolage-grotesque';\n  src: local('bricolage-grotesque'), url(../fonts/BricolageGrotesque-VariableFont_opsz,wdth,wght.ttf) format('truetype');\n  /* other formats include: 'woff2', 'truetype, 'opentype',\n                            'embedded-opentype', and 'svg' */\n}\n\n@font-face {\n  font-family: 'PT Sans';\n  src: local('PT Sans'), url(../fonts/PTSans-Regular.ttf) format('truetype');\n  /* other formats include: 'woff2', 'truetype, 'opentype',\n                            'embedded-opentype', and 'svg' */\n}\n\n.subImages {\n  position: relative; \n  max-width: 100%; \n  height:45em; \n  object-fit: scale-down; \n  align-self: center; \n  display: inline-block;\n  animation-name: none\n}\n\n.subImagesMobile {\n  position: relative; \n  max-width: 75%; \n  object-fit: scale-down; \n  align-self: center; \n  display: inline-block;\n  animation-name: none\n}\n.subImages2 {\n  position: relative; \n  max-width: 100%; \n  height:45em; \n  object-fit: scale-down; \n  align-self: center; \n  display: inline-block;\n  animation-name: none;\n}\n.subImages.fade {\n    animation: fadeIn 0.25s ease-in;\n}\n\n.PagesMobile {\n  font-family: 'PT Sans'; \n  font-style: normal;\n  line-height: 1.8em;\n  font-size: 1em; \n  color: #FCFCF7B3;\n  padding: 0.4em;\n  font-weight: 590;\n  cursor: pointer;\n}\n\n.Pages {\n  font-family: 'PT Sans'; \n  font-style: normal;\n  line-height: 1.8em;\n  font-size: 11px; \n  color: rgb(91, 87, 72);\n  padding: 0.2em;\n  font-weight: 590;\n  cursor: pointer;\n\n}\n\n.Pages:hover {\n  animation: changeColor 0.25s ease; /* Animation for zooming in */\n  cursor: pointer;\n  color: rgb(22, 21, 21);\n\n}\n\n.OtherPagesMobile {\n  font-family: 'proxima-nova'; \n  cursor: pointer;\n  font-style: normal;\n  line-height: 1.8em;\n  font-size: 1em; \n  color: #FCFCF7B3;\n  padding: 0.4em;\n  font-weight: 400;\n  letter-spacing: 0.22px;\n  padding-bottom: 1em\n\n}\n\n.OtherPages {\n  font-family: 'proxima-nova'; \n  cursor: pointer;\n  font-style: normal;\n  line-height: 1.8em;\n  font-size: 11px; \n  color: rgb(91, 87, 72);\n  padding: 0.2em;\n  font-weight: 400;\n  letter-spacing: 0.22px;\n\n}\n\n.OtherPages:hover {\n  animation: changeColor 0.25s ease; /* Animation for zooming in */\n  cursor: pointer;\n  color: rgb(22, 21, 21);\n\n}\n\n\n@keyframes changeColor {\n  from {\n    color: rgb(91, 87, 72);\n  }\n  to {\n    color: rgb(22, 21, 21);\n  }\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.zoomed-background {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  top: 0; \n  left: 0; \n  width: 100%; \n  height: 100%; \n  background-color: rgba(0,0,0,0.9);\n  animation: fadeToBlack 1s ease;\n  transition-timing-function: cubic-bezier(.25,.15,.65,.25);\n}\n@keyframes fadeToBlack {\n  from {background-color: rgba(0,0,0,0);}\n  to {background-color: rgba(0,0,0,0.9);}\n}\n\n.zoomed-photo {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n  animation: zoomIn 0.5s ease; /* Animation for zooming in */\n  transition: filter 0.5s ease;\n  transition-timing-function: cubic-bezier(.25,.15,.65,.25);\n  animation-timing-function: cubic-bezier(.25,.15,.65,.25);\n  font-size: 0pt;\n}\n\n.zoomed-photo.active {\n  animation: fadeIn 0.5s ease; /* Animation for zooming in */\n  transition: filter 0.5s ease;\n  transition-timing-function: cubic-bezier(.25,.15,.65,.25);\n  animation-timing-function: cubic-bezier(.25,.15,.65,.25);\n}\n\n@keyframes zoomIn {\n  from {\n    opacity: 0; /* Initial opacity */\n    font-size: 0pt;\n  }\n  to {\n    opacity: 1; /* Final opacity */\n    font-size: 0pt;\n  }\n}\n\n.zoomed-text {\n  text-align: center;\n  color: #ddddd0;\n  width: 50%;\n  animation: fadeIn 1.2s ease-in; /* Animation for zooming in */\n  animation-timing-function: cubic-bezier(.83,.24,.75,.54);\n  font-size: 12pt;\n}\n\n.zoomed-title-text {\n  font-weight: bold;\n  text-align: center;\n  color: #ddddd0;\n  padding: 2.5vh;\n  font-size: 12pt;\n  animation: fadeIn 1s linear; /* Animation for zooming in */\n  animation-timing-function: cubic-bezier(.83,.24,.75,.54);\n}\n\n.zoomed-text-odd {\n  text-align: center;\n  color: #ddddd0;\n  width: 50%;\n  animation: fadeIn 1.7s ease-in; /* Animation for zooming in */\n  animation-timing-function: cubic-bezier(.83,.24,.75,.54);\n  font-size: 12pt;\n\n}\n\n.zoomed-title-text-odd {\n  font-weight: bold;\n  text-align: center;\n  color: #ddddd0;\n  padding: 2.5vh;\n  font-size: 12pt;\n  animation: fadeIn 0.3s ease-in; /* Animation for zooming in */\n  animation-timing-function: cubic-bezier(.83,.24,.75,.54);\n\n\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: .5; /* Initial opacity */\n    font-size: 12pt;\n  }\n  to {\n    opacity: 1; /* Final opacity */\n    font-size: 12pt;\n  }\n}\n\n@keyframes slideIn {\n  from {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    /* height: 56vh; */\n\n    transform: translateY(-100%);\n    opacity: 0.5; /* Initial opacity */\n    font-size: 12pt;\n  }\n  to {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    /* height: 56vh; */\n    transform: translateY(0%);\n    opacity: 1; /* Final opacity */\n    font-size: 12pt;\n  }\n}\n\n@keyframes slideOut {\n  from {\n    opacity: 1; /* Initial opacity */\n    opacity: 1; /* Initial opacity */\n    font-size: 12pt;\n  }\n  to {\n    opacity: 0; /* Final opacity */\n    transform: translateY(-100%);\n    opacity: 0; /* Final opacity */\n    font-size: 12pt;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
